import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

interface ISortTargetValue {
  name: string;
  value: string;
}

@Component({
    selector: 'app-sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss'],
    standalone: false
})
export class SortComponent implements OnChanges {

  @Input() sortTarget: UntypedFormControl;
  @Input() sortOrder: UntypedFormControl;
  @Input() sortTargetValue: ISortTargetValue;

  ngOnChanges() { }
}
